export const SCHOOL = {
  name: "Trinity Musical School",
  org: "Amici per la Musica APS",
  tagline: "music · drama · performing arts",
  subtitle: "L'evoluzione dell'eccellenza artistica e culturale",
  description: "Scuola di Musica e Spettacolo · Trinity College London Centre Registration Number 71607",
  email: "info@trinitymusicalschool.net",
  phones: [
    { label: "Provincia di Ferrara", value: "0532 171 6892", tel: "+390532171689​2" },
    { label: "Provincia di Rovigo", value: "0425 166 6483", tel: "+390425166648​3" },
    { label: "Cellulare", value: "391 396 58 24", tel: "+393913965824" },
    { label: "Cellulare", value: "391 308 47 61", tel: "+393913084761" },
  ],
  locations: [
    {
      id: "riva-del-po",
      name: "Sede di Riva del Po",
      city: "Riva del Po (FE)",
      address: "Piazza Mazzini 14 — località Ro",
      mapsQuery: "Piazza Mazzini 14, Ro, Riva del Po, Ferrara",
    },
    {
      id: "polesella",
      name: "Sede di Polesella",
      city: "Polesella (RO)",
      address: "Piazza Matteotti 112",
      mapsQuery: "Piazza Matteotti 112, Polesella, Rovigo",
    },
    {
      id: "rovigo",
      name: "Sede di Rovigo",
      city: "Rovigo",
      address: "Via Luigi Einaudi 16 — Area Tosi",
      mapsQuery: "Via Luigi Einaudi 16, Rovigo",
    },
  ],
  social: {
    facebook: "https://www.facebook.com/amiciperlamusica.aps/",
    instagram: "https://www.instagram.com/tms_amiciperlamusicaaps/",
    youtube: "https://www.youtube.com/@amiciperlamusicaaps",
  },
  whatsapp: {
    number: "+393913084761",
    text: "Salve, vi contatto dal sito Trinity Musical School per avere informazioni",
  },
  logo: "https://customer-assets.emergentagent.com/job_0e52844b-b1e4-41c2-bf02-225b3dd24c51/artifacts/zq19pqac_nuovo%20logo%20AMICI%20PER%20LA%20MUSICA.jpg",
  trinityCentreId: "71607",
  founded: 2021,
  vatNumber: "93101090384",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Chi Siamo", to: "/chi-siamo" },
  {
    label: "Corsi",
    children: [
      { label: "Musica", to: "/corsi" },
      { label: "Teatro", to: "/teatro" },
    ],
  },
  {
    label: "Cori & Orchestra",
    children: [
      { label: "Cori · Trinity Vocal Hub", href: "https://trinityvocalhub.net/", external: true },
      { label: "Orchestra Giovanile", href: "https://www.trinityoungorchestra.eu/", external: true },
    ],
  },
  { label: "Insegnanti", to: "/insegnanti" },
  { label: "Eventi", to: "/eventi" },
  { label: "Masterclass", to: "/masterclass" },
  { label: "Progetti", to: "/progetti" },
  { label: "Galleria", to: "/galleria" },
  { label: "Reels", to: "/reels" },
  { label: "Trinity", to: "/certificazioni" },
  { label: "Blog", to: "/blog" },
  { label: "Iscrizione", to: "/iscrizione" },
  { label: "Sostienici", to: "/sostienici" },
  { label: "Area Soci", to: "/area-soci" },
  { label: "Contatti", to: "/contatti" },
  { label: "Amici per la Musica", href: "https://www.amiciperlamusica.org", external: true },
];
